import React from "react";

import { formatDecimal2 } from "~/utils";
import { HealthSummary } from "../Shared";

interface BloodPressureData {
  date: string;
  systolic: number;
  diastolic: number;
}

interface HourlyBloodPressureData {
  datetime: string;
  hour: number;
  systolic: number;
  diastolic: number;
}

interface BloodPressureSummaryProps {
  filteredData: (BloodPressureData | HourlyBloodPressureData)[];
  metadata: {
    systolic: number;
    diastolic: number;
  } | null;
  handlePrevious: () => void;
  handleNext: () => void;
  onDateSelect: (date: Date) => void;
  selectedDate: Date;
  selectedRange: string;
}

export const BloodPressureSummary: React.FC<BloodPressureSummaryProps> = ({
  filteredData,
  metadata,
  handlePrevious,
  handleNext,
  onDateSelect,
  selectedDate,
  selectedRange,
}) => {
  const getSummaryValues = (metadata: { systolic: number; diastolic: number } | null, _filteredData: (BloodPressureData | HourlyBloodPressureData)[]) => [
    {
      label: "Systolic",
      value: formatDecimal2(metadata?.systolic ?? 0),
      color: "#3b82f6", // blue-500
      unit: "mmHg",
    },
    {
      label: "Diastolic",
      value: formatDecimal2(metadata?.diastolic ?? 0),
      color: "#ef4444", // red-500
      unit: "mmHg",
    },
  ];

  return (
    <HealthSummary
      filteredData={filteredData}
      metadata={metadata}
      handlePrevious={handlePrevious}
      handleNext={handleNext}
      onDateSelect={onDateSelect}
      selectedDate={selectedDate}
      selectedRange={selectedRange}
      getSummaryValues={getSummaryValues}
    />
  );
};